import {
  CreditCardFill,
  FileEarmarkFill,
  PersonLinesFill,
  ShieldLockFill,
} from "react-bootstrap-icons";
export const CARDS_CONTEXT = [
  {
    title: "تسويه حساب به موقع",
    icon: <CreditCardFill width={50} height={100} color="#5a7fe5" />,
    description: `تسويه حساب مطابق با زمانبندی توافق شده تضمين شده است مشتريان
        خدمات اجتماعی به صورت پیش فرض از تسويه حساب روزانه ما بهره مندن
        خواهند بود`,
  },
  {
    title: "تضمين امنيت پرداخت",
    icon: <ShieldLockFill width={50} height={100} color="#5a7fe5" />,
    description: `  پولبان با اتکا به مميزهايی رسمی تضمين امنيت و همکاری با شرکت های
    معظم PSP
   
    پرداخت امن و شفاف را تضمين می نمايد`,
  },
  {
    title: "پشتيبانی لحظه ای",
    icon: <PersonLinesFill width={50} height={100} color="#5a7fe5" />,
    description: `تيم فنی پولبان در تمامی مراحل راه اندازی و بهره برداری از درگاه
    پرداخت در کنار شماست `,
  },
  {
    title: "ساختار کارمزد انعطاف پذير",
    icon: <FileEarmarkFill width={50} height={100} color="#5a7fe5" />,
    description: ` ما مدل محاسبه کارمزد را با مذاکره با فضای کسب و کار شما تطبيق می
    دهيم .  
    «برد ـ برد» مدل پيشنهادی ماست`,
  },
];
